import { HOST_URL } from '../../config'
import { HttpStatus } from '../../constants/http-status.enum'
import type { ApiResponse } from '../index'
import type { IClientUID } from '../clients'

export async function updateClientDateTime(clientId: IClientUID, dateTime: number): Promise<ApiResponse<void>> {
    const response = await fetch(`${HOST_URL}datetime`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ clientId, dateTime }),
    })
    const result = (await response.json()) as ApiResponse<void>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
